var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerificationWaitState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.916 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 124.556,
    height: 74,
    rx: 9,
    fill: "#FFF",
    stroke: "#5E667D"
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.12,
    fill: "#061437",
    x: 53.556,
    y: 13.5,
    width: 50.538,
    height: 6.811,
    rx: 2.057
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.36,
    fill: "#061437",
    opacity: 0.23,
    x: 53.556,
    y: 26.365,
    width: 63,
    height: 6.811,
    rx: 2.057
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.12,
    fill: "#061437",
    x: 53.556,
    y: 50.257,
    width: 24.048,
    height: 3.892,
    rx: 1.946
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.12,
    fill: "#061437",
    x: 86.578,
    y: 50.257,
    width: 24.048,
    height: 3.892,
    rx: 1.946
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.36,
    fill: "#061437",
    opacity: 0.23,
    x: 53.556,
    y: 57.608,
    width: 29.978,
    height: 3.892,
    rx: 1.946
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.36,
    fill: "#061437",
    opacity: 0.23,
    x: 86.578,
    y: 57.608,
    width: 29.978,
    height: 3.892,
    rx: 1.946
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.471 85)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FF933C",
    width: 36,
    height: 36,
    rx: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.99 8C12.47 8 8 12.48 8 18s4.47 10 9.99 10C23.52 28 28 23.52 28 18S23.52 8 17.99 8ZM18 26c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24a.71.71 0 0 0-.25-.99l-3.87-2.3v-4.54c0-.4-.32-.72-.72-.72Z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.76 54.675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.769 0H37.88c2.006 0 2.734.209 3.467.601a4.089 4.089 0 0 1 1.701 1.701c.392.733.601 1.46.601 3.467V38.03c0 2.006-.209 2.733-.601 3.467a4.089 4.089 0 0 1-1.701 1.7c-.733.393-1.46.602-3.467.602H5.77c-2.006 0-2.734-.209-3.467-.601a4.089 4.089 0 0 1-1.701-1.701C.209 40.763 0 40.036 0 38.03V5.77c0-2.006.209-2.734.601-3.467A4.089 4.089 0 0 1 2.302.601C3.035.209 3.762 0 5.77 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15 39.21c1.824-5.211 5.694-8.534 9.945-8.538h8.964c4.61 0 8.25 2.678 9.844 8.55L7.15 39.21Z",
    fill: "#BDC1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.697 13.966c1.235-3.934 4.041-7.54 7.922-8.872 3.882-1.33 10.653-.086 12.484 3.604 2.637 5.32 1.452 11.834.054 17.609-.73-.039-1.466-.069-2.205-.096l-1.045-3.481v3.446c-5.762-.178-11.761-.066-17.763.05-.537-4.089-.68-8.327.553-12.26Z",
    fill: "#9EA6B5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 20.154,
    cy: 17.79,
    r: 8.837
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.39 7.143a10.455 10.455 0 0 1 15.896 9.125c-4.653.214-9.54.27-14.497.28l-1.172-2.868-.69 2.87c-1.51 0-3.024-.003-4.54-.007a10.676 10.676 0 0 1 5.003-9.4Z",
    fill: "#9EA6B5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerificationWaitState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/verification-wait-state.59d3f041fee7e053115875063318322b.svg";